<div
  class="cv-dialog__backdrop"
  [class.cv-dialog__backdrop--max-priority]="maxPriority()"
  [class.cv-dialog__backdrop--dark]="backdrop() === 'dark'"
  role="presentation"
></div>

<div
  class="cv-dialog ui-dialog Ilit_alert_box"
  [class.cv-dialog--max-priority]="maxPriority()"
  [style.width.px]="width()"
  [style.max-width]="'min(' + width() + 'px, calc(100vw - 32px))'"
  role="alertdialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId()"
  [attr.aria-describedby]="bodyId()"
  cdkTrapFocus
  cdkTrapFocusAutoCapture
  (keydown)="onKeydown($event)"
>
  <div class="cv-dialog__title ui-dialog-titlebar" [attr.id]="titleId()">
    <span class="ui-dialog-title">{{ title() }}</span>
  </div>

  <!-- Projected content wins; the message keeps its own line breaks. -->
  <div class="cv-dialog__body Ilit_alert_box ui-dialog-content" [attr.id]="bodyId()">
    <ng-content>
      <span class="cv-dialog__message">{{ message() }}</span>
    </ng-content>
  </div>

  @if (buttons().length) {
    <div class="cv-dialog__footer ui-dialog-buttonpane">
      <div class="cv-dialog__buttonset ui-dialog-buttonset">
        @for (button of buttons(); track button.label) {
          <button
            type="button"
            class="cv-dialog__button ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"
            [class.cv-dialog__button--confirm]="button.role === 'confirm'"
            [class.cv-dialog__button--cancel]="button.role === 'cancel'"
            (click)="onButton(button)"
          >
            <span class="ui-button-text">{{ button.label }}</span>
          </button>
        }
      </div>
    </div>
  }
</div>
